package org.hs_soft.runmynesto.pages.components.dialog.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onMouseDown
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.onMouseUp
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.LetterSpacing
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.blueGradientEffect
import org.hs_soft.runmynesto.domain.config.transitionBackground
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.pages.components.CircularProgress
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun CustomButton(
    modifier: Modifier=Modifier,
    windowSizeMode: WindowSizeModeEnum = WindowSizeModeEnum.Desktop,
    width:CSSSizeValue<CSSUnit.px> =if (windowSizeMode!= WindowSizeModeEnum.PHONE)
            Dimen.mediumSubmitButtonWidth
        else Dimen.submitButtonPhoneWidth,
    icon:String?=null,
    iconSize:Int = Dimen.mediumIconSize,
    iconTint:String=Theme.White.hex,
    title: String,
    isClickable: Boolean =true,
    loading:Boolean=false,
    buttonType: ButtonTypes,
    onButtonClick: () -> Unit,
) {
    val isHovered= remember { mutableStateOf(false) }
    val isFocused = remember { mutableStateOf(false) }


    Row(
        modifier = modifier
            .minWidth(width)
            .position(Position.Relative)
            .minHeight(Dimen.submitButtonHeight)
            .height(Dimen.submitButtonHeight)
            .padding(leftRight = Dimen.normalPadding)
            .onMouseOver {isHovered.value=true }
            .onMouseLeave { isHovered.value=false }
            .onMouseDown {isFocused.value=true}
            .onMouseUp { isFocused.value=false }
            .cursor(Cursor.Pointer)
            .blueGradientEffect(isClickable && !loading) {
                onButtonClick()
            }
            .backgroundColor(
                when(buttonType)
                {
                    ButtonTypes.CONTAINED->{
                        if(!isClickable){
                            Theme.ActionDisabledBackground.rgb
                        }else if (loading){
                            Theme.ActionDisabledBackground.rgb
                        }else if (isFocused.value){
                            Theme.PrimaryDark.rgb
                        }
                        else if(isHovered.value){
                            Theme.PrimaryDark.rgb
                        }else{
                            Theme.PrimaryMain.rgb
                        }
                    }
                    ButtonTypes.OUTLINED->{
                        if(!isClickable){
                            Theme.ActionDisabledBackground.rgb
                        }else if (loading){
                            Theme.ActionDisabledBackground.rgb
                        }else if (isFocused.value){
                            Theme.PrimaryStatesFocus.rgb
                        }
                        else if(isHovered.value){
                            Theme.PrimaryStatesHover.rgb
                        }else{
                            Theme.White.rgb
                        }
                    }
                    ButtonTypes.TEXT->{
                        if(!isClickable){
                            Theme.Transparent.rgb//TODO(Must be changed)
                        }else if (loading){
                            Theme.Transparent.rgb//TODO(Must be changed)
                        }else if (isFocused.value){
                            Theme.PrimaryStatesFocus.rgb
                        }
                        else if(isHovered.value){
                            Theme.PrimaryStatesHover.rgb
                        }else{
                            Theme.Transparent.rgb
                        }
                    }

                }
            )
            .border(
                width = if (buttonType!=ButtonTypes.TEXT) Dimen.smallThickness
                  else 0.px  ,
                style = LineStyle.Solid,
                color = when(buttonType){
                    ButtonTypes.CONTAINED->{
                        Theme.Transparent.rgb
                    }
                    ButtonTypes.OUTLINED->{
                        Theme.PrimaryStatesOutlinedBorder.rgb
                    }
                    ButtonTypes.TEXT->{
                        Theme.PrimaryStatesOutlinedBorder.rgb
                    }
                }
            )
            .borderRadius(Dimen.lowBorderRadius)
            .transitionBackground(),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically,

    )
    {

        if (!loading && icon!=null){
            VectorIcon(
                modifier=Modifier
                    .margin(right = Dimen.smallPadding),
                pathData = icon,
                color =iconTint,
                width =iconSize ,
                height =iconSize ,
            )

        }

        if (loading){
            CircularProgress(
                modifier=Modifier.margin(right = Dimen.smallPadding),
                color = Theme.TextDisabled.rgb,
                size = Dimen.smallIconSize.px,
            )
        }

        SpanText(
            text = title,
            modifier = Modifier
                .fontSize(FontSizes.semiMediumFontSize)
                .fontWeight(FontWeight.Medium)
                .letterSpacing(LetterSpacing.extraLarge)
                .lineHeight(FontLineHeight.lineSemiLarge)
                .fontFamily(FontFamily.Jakarta)
                .color(
                    when(buttonType){
                        ButtonTypes.CONTAINED->{
                            if (!isClickable || loading)
                                Theme.TextDisabled.rgb
                            else Theme.White.rgb
                        }
                        ButtonTypes.OUTLINED->{
                            if (!isClickable || loading)
                                Theme.TextDisabled.rgb
                            else Theme.PrimaryMain.rgb
                        }
                        ButtonTypes.TEXT->{

                            if (!isClickable || loading)
                                Theme.TextDisabled.rgb
                            else Theme.PrimaryMain.rgb
                        }
                    }
                )
        )
    }
}